/**
 * Formatter numerico condiviso dal calendario giornaliero e dai
 * sotto-componenti forecast/banner. Estratto da `CalendarTab.js`
 * il 2026-05-29 per consentire lo split senza dipendenze cicliche.
 *
 *   fmt(123.45, 'currency')          → "123,45 €"
 *   fmt(1234, 'currency-compact')    → "1,2 k€"
 *   fmt(67.3, 'percentage')          → "67.3%"
 *   fmt(1234, 'integer')             → "1.234"
 *   fmt(1.234, 'decimal')            → "1,2"
 *   fmt(null, 'currency')            → "—"
 */
export function fmt(val, format) {
  if (val == null) return '—';
  if (format === 'currency') {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(val);
  }
  if (format === 'currency-compact') {
    if (Math.abs(val) >= 1000) {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency', currency: 'EUR', notation: 'compact', maximumFractionDigits: 1,
      }).format(val);
    }
    return new Intl.NumberFormat('it-IT', {
      style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
    }).format(val);
  }
  if (format === 'percentage') return `${val.toFixed(1)}%`;
  if (format === 'integer') return Math.round(val).toLocaleString('it-IT');
  if (format === 'decimal') return val.toLocaleString('it-IT', { maximumFractionDigits: 1 });
  return val.toLocaleString('it-IT', { maximumFractionDigits: 2 });
}
